<template>
  <el-dialog
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    fullscreen
    destroy-on-close
  >
    <div>
      <el-row>
        <el-col :span="8">
          <div style="text-align: left; margin-right: 16px">
            <div>
              <el-form :size="size" label-width="80px">
                <el-form-item :label="$t('areatype.title')">
                  <el-radio-group v-model="AreaType">
                    <el-radio :label="0">{{
                      $t("areatype.circular")
                    }}</el-radio>
                    <el-radio :label="1">{{
                      $t("areatype.rectangle")
                    }}</el-radio>
                    <el-radio :label="2">{{ $t("areatype.polygon") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                  <el-button @click="drawArea" type="primary">{{
                    drawing
                      ? $t("arealimitset.cancelareaset")
                      : $t("arealimitset.clickareaset")
                  }}</el-button
                  ><span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >{{ $t("arealimitset.opeinmap") }}</span
                  >
                </el-form-item>
                <el-form-item :label="$t('arealimitset.areaname')">
                  <el-input v-model="AreaName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.arealimitspeed')">
                  <el-input-number
                    v-model="MaxSpeed"
                    :min="5"
                    :max="100"
                  ></el-input-number>
                  <span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >km/h({{ $t("public.EffectiveRange") }}:5~100)</span
                  >
                </el-form-item>
                <el-form-item label-width="0">
                  <span style="color: #ff8c00; font-size: 12px"
                    ><kl-icon
                      :size="12"
                      icon="icon-icon_prompt2"
                      style="margin-right: 6px"
                    />{{ $t("arealimitset.lab2") }}</span
                  >
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSaveClick" :size="size">{{
                    $t("public.save")
                  }}</el-button>
                  <el-button @click="dialogVisible = false" :size="size">{{
                    $t("public.cancel")
                  }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="16" style="height: calc(100vh - 100px)">
          <KingLongMap
            ref="map_info"
            mapId="content_1"
             
            v-if="dialogVisible"
            @DrawRectangleCompleted="DrawRectangleCompleted"
            @LoadCompleted="mapLoadCompleted"
            @DrawPolygonCompleted="DrawPolygonCompleted"
            @DrawCircleCompleted="DrawCircleCompleted"
          />
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import KingLongMap from "@/components/KingLongMap.vue";
export default {
  components: { KingLongMap },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },

  data() {
    return {
      title: this.$t("arealimitset.addlimitarea"),
      dialogVisible: false,
      drawing: false, //正在绘制区域中
      MaxSpeed: 5,
      AreaName: "",
      AreaType: 2,
      AreaID: -1,
      AreaAttribute: 1280, //0x0500 如何计算
      Lonlats: "",
      AddedInfo: "",

      mapLoaded: false,
    };
  },
  methods: {
    add() {
      this.edit({});
      this.AreaID = -1;
      this.AreaType = 2;
      this.MaxSpeed = 5;
      this.AreaName = "";
      this.Lonlats = "";
      this.AddedInfo = "";

      this.AreaAttribute = 1280;
      this.title = this.$t("arealimitset.addlimitarea");
    },
    edit(row) {
      this.AreaAttribute = row.AreaAttribute;
      this.AreaID = row.AreaID;
      this.MaxSpeed = row.MaxSpeed;
      this.AreaName = row.AreaName;
      this.AreaType = row.AreaType;
      this.Lonlats = row.Lonlats;
      this.AddedInfo = row.AddedInfo;
      this.title = this.$t("arealimitset.editlimitarea");

      this.dialogVisible = true;
    },
    mapLoadCompleted() {
      if (!this.mapLoaded) {
        this.mapLoaded = true;
      }
      this.$nextTick(() => {
        this.showArea();
      });
    },
    showArea() {
      this.$refs.map_info.clearAll();

      if (this.Lonlats || this.AddedInfo) {
        switch (this.AreaType) {
          case 0:
            var circleInfo = this.AddedInfo.split(",");
            if (circleInfo.length == 3) {
              this.$refs.map_info.addCircle(
                this.AreaID,
                { lng: circleInfo[1], lat: circleInfo[2] },
                circleInfo[0]
              );
            }

            break;
          case 1: //矩形
            //todo  缩放到适当的区域
            var circleInfo = this.Lonlats.split(";");

            var ne = circleInfo[0].split(",");
            var sw = circleInfo[1].split(",");

            var lon = (parseFloat(ne[1]) + parseFloat(sw[1])) / 2;
            var lat = (parseFloat(ne[2]) + parseFloat(sw[2])) / 2;

            var coordanites = [];
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(ne[2]),
            });
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(ne[2]),
            });

            this.$refs.map_info.addPolygon(
              "AREA1",
              this.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
          case 2: //多边形
            //todo  缩放到适当的区域
            var circleInfo = this.Lonlats.split(";");

            var center = circleInfo[0].split(",");

            var coordanites = [];
            circleInfo.forEach((element) => {
              var p = element.split(",");
              coordanites.push({
                lng: parseFloat(p[1]),
                lat: parseFloat(p[2]),
              });
            });
            this.$refs.map_info.addPolygon(
              "AREA1",
              this.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );
            break;
        }
      }
    },
    onSaveClick() {
      //数据保存
      //非空判断
      if (this.AreaName === "") {
        this.$message.warning(this.$t("arealimitset.areanameempty"));
        return;
      } else if (this.MaxSpeed == "") {
        this.$message.warning(this.$t("arealimitset.arealimitempty"));
        return;
      } else if (this.MaxSpeed < 5 || this.MaxSpeed > 100) {
        this.$message.warning(this.$t("arealimitset.arealimitrange"));
        return;
      }
      if (!this.AddedInfo && !this.Lonlats) {
        this.$message.warning(this.$t("arealimitset.areaempty"));
        return;
      }
      //保存到数据库
      this.$api
        .saveSpeedLimitArea({
          AreaID: this.AreaID,
          AreaName: this.AreaName,
          AreaType: this.AreaType,
          MaxSpeed: this.MaxSpeed,
          lonlats: this.Lonlats,
          AddedInfo: this.AddedInfo,
          AreaAttribute: this.AreaAttribute,
          OperatorID: this.operator.OperatorId,
          CompanyID: this.operator.CompanyId,
          UseState: 1,
        })
        .then((res) => {
          this.$message.success(this.$t('public.hasSaved'));
          this.$emit("ok");
          this.dialogVisible = false;
        });
      //重新加载列表
    },
    DrawRectangleCompleted(lng1, lat1, lng2, lat2) {
      this.drawing = false;
      this.Lonlats = "1," + lng1 + "," + lat1 + ";" + "2," + lng2 + "," + lat2;
      this.AddedInfo = "";
    },
    DrawPolygonCompleted(lnglats) {
      this.drawing = false;
      var aryPoint = lnglats.split(";");
      if (aryPoint.length > 125) {
        //绘制多边形节点不能超出上限125个
        return;
      }

      var lonlats = "";
      for (var i = 0; i < aryPoint.length; i++) {
        if (lonlats != "") lonlats += ";";
        lonlats += i + "," + aryPoint[i];
      }

      this.Lonlats = lonlats;
      this.AddedInfo = "";
    },

    DrawCircleCompleted(lng, lat, radius) {
      this.drawing = false;
      this.Lonlats = "";
      this.AddedInfo = radius + "," + lng + "," + lat;
    },

    drawArea() {
      //画区域
      if (this.drawing) {
        //正在画，取消画
        this.$refs.map_info.cancelDraw();
        this.drawing = false;
      } else {
        //根据选中类型进行
        switch (this.AreaType) {
          case 0:
            this.$refs.map_info.drawCircle();
            break;
          case 1:
            this.$refs.map_info.drawRectangle();
            break;
          case 2:
            this.$refs.map_info.drawPolygon();
            break;
        }

        this.drawing = true;
      }
    },
  },
};
</script>
